import { ChangeDetectionStrategy, Component, ElementRef, contentChild, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'xemex-select-field',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './select-field.component.html',
  styleUrl: './select-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.invalid]': 'invalid()',
  },
})
export class SelectFieldComponent {
  label = input.required<string>();
  required = input(false);
  invalid = input(false);
  errorText = input('');

  /** Present only when a <mat-select> is projected (not for autocomplete/country-list usages). */
  protected readonly matSelect = contentChild(MatSelect);
  private readonly matSelectRef = contentChild(MatSelect, { read: ElementRef });

  /**
   * The mat-select trigger only covers the value text, leaving the box padding,
   * chevron and the space above/below it unclickable. Forward those clicks so the
   * whole box opens the dropdown; clicks on the select itself are left to Material.
   */
  protected openOnBoxClick(event: MouseEvent): void {
    const select = this.matSelect();
    if (!select || select.disabled) return;
    if (this.matSelectRef()?.nativeElement.contains(event.target as Node)) return;
    select.open();
  }
}
